import { Button } from "@/components/flexkit/Button";
import { cn } from "@/components/podkit/lib/cn";
import { withGitpodSize } from "@/assets/icons/utils";
import IconCirclePlus from "central-icons/IconCirclePlus";
import type { FC } from "react";

const IconCirclePlusWithSize = withGitpodSize(IconCirclePlus);

export type NewAutomationStepButtonProps = {
    isAddingStep: boolean;
    onAddStep: () => void;
};

export const NewAutomationStepButton: FC<NewAutomationStepButtonProps> = ({ isAddingStep, onAddStep }) => {
    return (
        <li className="flex w-full items-center gap-2 pt-3">
            <Button
                variant="primary"
                size="sm"
                LeadingIcon={IconCirclePlusWithSize}
                className={isAddingStep ? "outline outline-offset-2 outline-border-brand" : ""}
                onClick={() => {
                    onAddStep();
                }}
                data-tracking-id="step"
            >
                Step
            </Button>
            <hr
                className={cn(
                    "h-[1.5px] flex-1 rounded-full border-0",
                    isAddingStep ? "bg-border-brand" : "bg-border-strong",
                )}
            />
        </li>
    );
};
